<template>
  <v-dialog
    v-model="showDialog"
    :max-width="maxWidth"
    scrollable
    @after-leave="$emit('after-leave')"
  >
    <SimpleCard :title="title">
      <div>
        <slot />
      </div>

      <template #actions>
        <ActionButton
          v-if="showCancel || showClose"
          :cancel="showCancel"
          :close="showClose"
          @click="showDialog=false"
        />
        <slot name="actions" />
      </template>
    </SimpleCard>
  </v-dialog>
</template>

<script>
  import SimpleCard from '../card/SimpleCard'
  import ActionButton from '../button/ActionButton'

  export default {
    components: { ActionButton, SimpleCard },
    props: {
      dialog: Boolean,
      title: {
        type: String,
        default: ''
      },
      showCancel: Boolean,
      showClose: Boolean,
      maxWidth: { type: String, default: '1200' }
    },
    emits: ['update:dialog', 'after-leave'],
    data: () => ({
      showDialog: false
    }),
    watch: {
      dialog () {
        this.showDialog = this.dialog
      },
      showDialog () {
        this.$emit('update:dialog', this.showDialog)
      }
    },
    created () {
      this.showDialog = this.dialog
    }
  }
</script>
